import * as React from 'react';

const PuzzleSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={48} height={48} fill="none" {...props}>
        <g id="puzzle_svg__Puzzle">
            <path fill="#fff" d="M0 0h48v48H0z" />
            <path
                id="puzzle_svg__Path"
                d="M24 18.005v-2.677a4.5 4.5 0 110-5.656V1h20a3 3 0 013 3v20h-8.672a4.5 4.5 0 10-5.656 0H24"
                stroke="#1D0A32"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                id="puzzle_svg__Path_2"
                d="M24 24h-8.673a4.5 4.5 0 11-5.656 0H1V4a3 3 0 013-3h20v8.673a4.5 4.5 0 100 5.655"
                stroke="#1D0A32"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                id="puzzle_svg__Path_3"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 47a3 3 0 01-3-3V24h8.672a4.5 4.5 0 105.656 0H24v8.673a4.5 4.5 0 110 5.655v8.673H4z"
                stroke="#1D0A32"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                id="puzzle_svg__Path_4"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M47 44a3 3 0 01-3 3H24v-8.672a4.5 4.5 0 100-5.655V24l8.673.001a4.5 4.5 0 115.655 0H47v20z"
                stroke="#1D0A32"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
    </svg>
);

PuzzleSvg.displayName = 'PuzzleSvg';
export default PuzzleSvg;
